import React from 'react';

import { useTranslation } from 'react-i18next';
import { Project } from '../../../../types/Project';
import {
  getFriendlyDate,
  getFriendlyScheduledDuration,
  getFriendlyElapsedDuration,
  getTimezoneName,
} from '../../../../helpers/dateFormatHelper/dateFormatHelper';
import Row from '../../../Layout/Row/Row';
import BaseProjectSummaryCardBlock from './BaseProjectSummaryCardBlock';

import './BaseProjectSummaryCardBlock.scss';

type Props = {
  heading: string;
  project: Project;
};

const ProjectSummaryCardBlockGeneral = ({ heading, project }: Props) => {
  const { t } = useTranslation();
  const friendlyCreatedDate = getFriendlyDate(project?.created);
  const friendlyStartTime = getFriendlyDate(project?.scheduledDateTime);
  const friendlyDuration = getFriendlyScheduledDuration(project?.scheduledDuration ?? 0);
  const friendlyElapsedTime = !project?.duration
    ? t('project.not-elapsed')
    : getFriendlyElapsedDuration(project?.duration.toString() || '');
  const friendlyStreamedDate = !project?.scheduledDuration
    ? t('project.not-streamed')
    : getFriendlyDate(project?.broadcastStarted);

  return (
    <BaseProjectSummaryCardBlock heading={heading}>
      <Row
        left={t('project.created-date')}
        right={friendlyCreatedDate}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('project.scheduled-for')}
        right={friendlyStartTime}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('project.duration')}
        right={friendlyDuration}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('project.time-zone')}
        right={getTimezoneName(
          project?.scheduledDateTime || new Date(),
          project?.scheduledDateTime || '00:00:00',
          project?.scheduledTimeZone,
        )}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('project.streamed')}
        right={friendlyStreamedDate}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('project.elapsed-duration')}
        right={friendlyElapsedTime}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
    </BaseProjectSummaryCardBlock>
  );
};

export default ProjectSummaryCardBlockGeneral;
